import {
  Modal as OriginalModal,
  ModalBody as OriginalModalBody,
  ModalFooter as OriginalModalFooter,
  ModalHeader as OriginalModalHeader,
} from "baseui/modal";

export const BaseModal = OriginalModal;
export const BaseModalFooter = OriginalModalFooter;

export const BaseModalHeader = ({ style, className, ...props }: any) => (
  <>
    <OriginalModalHeader
      style={{ fontWeight: 500, fontSize: "1.25rem", ...style }}
      className={`text-gray-900 dark:text-gray-100 ${className || ""}`}
      {...props}
    />
    <hr className="dark:border-gray-700" />
  </>
);

export const BaseModalBody = OriginalModalBody;
